export interface ShipperAccount {
  id: string;
  key: string;
  description: string;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  account: string;
  userId: string;
  password: string;
  interfaceUrl: string;
  connectionName: string;
  connectionsId: string;
  sellingCompanyId: string;
  sellingCompanyKey: string;
  sellingCompanyName: string;
  warehouseId: string;
  warehouseKey: string;
}
